module.exports = __webpack_public_path__ + "static/img/m_order_ed.8aa00d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/m_order_ed.png
// module id = DTfV
// module chunks = 9